export const API_VERSION = process.env.REACT_APP_API || 'v1';
export const API_HOST = process.env.REACT_APP_API_HOST || 'https://moje.mooveno.pl/portal/';
export const SENTRY_URL = process.env.REACT_APP_SENTRY_URL || ''; 
